import { matchPath, useLocation } from 'react-router-dom';

export const useRouteMatch = () => {
  const { pathname } = useLocation();

  const getMatchObject = (patterns: readonly string[]) => {
    for (let i = 0; i < patterns.length; i += 1) {
      const pattern = patterns[i];
      const possibleMatch = matchPath(pattern, pathname);
      if (possibleMatch !== null) {
        return possibleMatch;
      }
    }

    return null;
  };

  /**
   * Returns the match object for the first pattern that matches the current location.
   * @param patterns - An array of patterns to test against the current location.
   * @returns The match object for the first pattern that matches the current location.
   * @example
   * // If the current location is '/profile/123'
   * const match = useRouteMatch(['/profile/:id', '/profile']);
   * if (match !== null) {
   *   console.log(match.pattern?.path); // '/profile/:id'
   *   console.log(match.params); // { id: '123' }
   * }
   */
  const isMatching = (patterns: readonly string[]) => {
    return getMatchObject(patterns) !== null;
  };

  return {
    getMatchObject,
    isMatching,
  };
};
